import { createReducer } from '@reduxjs/toolkit'
import { uniqBy, without } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  queue: [],
}

export default createReducer(INITIAL_STATE, {
  [types.ADD_SNACKBAR_ITEM]: (state, action) => ({
    queue: uniqBy([...state.queue, action.payload], 'key'),
  }),
  [types.DISMISS_SNACKBAR_ITEM]: (state, action) => ({
    queue: without(state.queue, action.payload),
  }),
})
